import { Instance, types } from 'mobx-state-tree';

export const MasteryLearningObjective = types.model('MasteryLearningObjective', {
  name: types.string,
  title: '',
  description: '',
});

export interface IMasteryLearningObjective extends Instance<typeof MasteryLearningObjective> {}
